export class StatsFlowdy2 {

  bando1Totali: number=0;
  bando2Totali: number=0;

  bando1InLavorazione: number=0;
  bando2InLavorazione: number=0;

  bando1Fase1:              number=0;
  bando1Fase1InLavorazione: number=0;
  bando1Fase1_sopralluogo_da_pianificare: number=0;
  bando1Fase1_sopralluogo_pianificato:    number=0;
  bando1Fase1_sopralluogo_effettuato:     number=0;

  bando1Fase1_lotto6:       number=0;
  bando1Fase1_lotto7:       number=0;
  bando1Fase1_1:            number=0;
  bando1Fase1_1_lotto6:     number=0;
  bando1Fase1_1_lotto7:     number=0;
  bando1Fase1_2:            number=0;
  bando1Fase1_2_lotto6:     number=0;
  bando1Fase1_2_lotto7:     number=0;
  bando1Fase1_3:            number=0;
  bando1Fase1_3_lotto6:     number=0;
  bando1Fase1_3_lotto7:     number=0;
  bando1Fase1_4:            number=0;
  bando1Fase1_4_lotto6:     number=0;
  bando1Fase1_4_lotto7:     number=0;
  bando1Fase1_5:            number=0;
  bando1Fase1_5_lotto6:     number=0;
  bando1Fase1_5_lotto7:     number=0;
  bando1Fase1_6:            number=0;
  bando1Fase1_6_lotto6:     number=0;
  bando1Fase1_6_lotto7:     number=0;

  prontofibraBando1:        number=0;
  prontofibraBando1_lotto6: number=0;
  prontofibraBando1_lotto7: number=0;

  bando1Fase2:              number=0;
  bando1Fase2InLavorazione: number=0;
  bando1Fase2_lotto6:       number=0;
  bando1Fase2_lotto7:       number=0;
  bando1Fase2_1:            number=0;
  bando1Fase2_1_lotto6:     number=0;
  bando1Fase2_1_lotto7:     number=0;
  bando1Fase2_2:            number=0;
  bando1Fase2_2_lotto6:     number=0;
  bando1Fase2_2_lotto7:     number=0;
  bando1Fase2_3:            number=0;
  bando1Fase2_3_lotto6:     number=0;
  bando1Fase2_3_lotto7:     number=0;
  bando1Fase2_4:            number=0;
  bando1Fase2_4_lotto6:     number=0;
  bando1Fase2_4_lotto7:     number=0;
  bando1Fase2_5:            number=0;
  bando1Fase2_5_lotto6:     number=0;
  bando1Fase2_5_lotto7:     number=0;
  bando1Fase2_6:            number=0;
  bando1Fase2_6_lotto6:     number=0;
  bando1Fase2_6_lotto7:     number=0;

  bando1Fase3:              number=0;
  bando1Fase3InLavorazione: number=0;
  bando1Fase3_lotto6:       number=0;
  bando1Fase3_lotto7:       number=0;
  bando1Fase3_1:            number=0;
  bando1Fase3_1_lotto6:     number=0;
  bando1Fase3_1_lotto7:     number=0;
  bando1Fase3_2:            number=0;
  bando1Fase3_2_lotto6:     number=0;
  bando1Fase3_2_lotto7:     number=0;
  bando1Fase3_3:            number=0;
  bando1Fase3_3_lotto6:     number=0;
  bando1Fase3_3_lotto7:     number=0;
  bando1Fase3_4:            number=0;
  bando1Fase3_4_lotto6:     number=0;
  bando1Fase3_4_lotto7:     number=0;
  bando1Fase3_5:            number=0;
  bando1Fase3_5_lotto6:     number=0;
  bando1Fase3_5_lotto7:     number=0;
  bando1Fase3_6:            number=0;
  bando1Fase3_6_lotto6:     number=0;
  bando1Fase3_6_lotto7:     number=0;

  bando1KO:                 number=0;
  bando1KO_lotto6:          number=0;
  bando1KO_lotto7:          number=0;



  bando2Fase1:              number=0;
  bando2Fase1InLavorazione: number=0;
  bando2Fase1_sopralluogo_da_pianificare: number=0;
  bando2Fase1_sopralluogo_pianificato:    number=0;
  bando2Fase1_sopralluogo_effettuato:     number=0;
  bando2Fase1_lotto1:       number=0;
  bando2Fase1_lotto5:       number=0;
  bando2Fase1_lotto7:       number=0;
  bando2Fase1_lotto8:       number=0;
  bando2Fase1_1:             number=0;
  bando2Fase1_2:             number=0;
  bando2Fase1_3:             number=0;
  bando2Fase1_4:             number=0;
  bando2Fase1_5:             number=0;
  bando2Fase1_6:             number=0;
  bando2Fase1_1_lotto1:     number=0;
  bando2Fase1_1_lotto5:     number=0;
  bando2Fase1_1_lotto7:     number=0;
  bando2Fase1_1_lotto8:     number=0;
  bando2Fase1_2_lotto1:     number=0;
  bando2Fase1_2_lotto5:     number=0;
  bando2Fase1_2_lotto7:     number=0;
  bando2Fase1_2_lotto8:     number=0;
  bando2Fase1_3_lotto1:     number=0;
  bando2Fase1_3_lotto5:     number=0;
  bando2Fase1_3_lotto7:     number=0;
  bando2Fase1_3_lotto8:     number=0;
  bando2Fase1_4_lotto1:     number=0;
  bando2Fase1_4_lotto5:     number=0;
  bando2Fase1_4_lotto7:     number=0;
  bando2Fase1_4_lotto8:     number=0;
  bando2Fase1_5_lotto1:     number=0;
  bando2Fase1_5_lotto5:     number=0;
  bando2Fase1_5_lotto7:     number=0;
  bando2Fase1_5_lotto8:     number=0;
  bando2Fase1_6_lotto1:     number=0;
  bando2Fase1_6_lotto5:     number=0;
  bando2Fase1_6_lotto7:     number=0;
  bando2Fase1_6_lotto8:     number=0;

  prontofibraBando2:        number=0;
  prontofibraBando2_lotto1: number=0;
  prontofibraBando2_lotto5: number=0;
  prontofibraBando2_lotto7: number=0;
  prontofibraBando2_lotto8: number=0;

  bando2Fase2:              number=0;
  bando2Fase2InLavorazione: number=0;
  bando2Fase2_lotto1:       number=0;
  bando2Fase2_lotto5:       number=0;
  bando2Fase2_lotto7:       number=0;
  bando2Fase2_lotto8:       number=0;
  bando2Fase2_1:             number=0;
  bando2Fase2_2:             number=0;
  bando2Fase2_3:             number=0;
  bando2Fase2_4:             number=0;
  bando2Fase2_5:             number=0;
  bando2Fase2_6:             number=0;
  bando2Fase2_1_lotto1:     number=0;
  bando2Fase2_1_lotto5:     number=0;
  bando2Fase2_1_lotto7:     number=0;
  bando2Fase2_1_lotto8:     number=0;
  bando2Fase2_2_lotto1:     number=0;
  bando2Fase2_2_lotto5:     number=0;
  bando2Fase2_2_lotto7:     number=0;
  bando2Fase2_2_lotto8:     number=0;
  bando2Fase2_3_lotto1:     number=0;
  bando2Fase2_3_lotto5:     number=0;
  bando2Fase2_3_lotto7:     number=0;
  bando2Fase2_3_lotto8:     number=0;
  bando2Fase2_4_lotto1:     number=0;
  bando2Fase2_4_lotto5:     number=0;
  bando2Fase2_4_lotto7:     number=0;
  bando2Fase2_4_lotto8:     number=0;
  bando2Fase2_5_lotto1:     number=0;
  bando2Fase2_5_lotto5:     number=0;
  bando2Fase2_5_lotto7:     number=0;
  bando2Fase2_5_lotto8:     number=0;
  bando2Fase2_6_lotto1:     number=0;
  bando2Fase2_6_lotto5:     number=0;
  bando2Fase2_6_lotto7:     number=0;
  bando2Fase2_6_lotto8:     number=0;


  bando2Fase3:              number=0;
  bando2Fase3InLavorazione: number=0;
  bando2Fase3_lotto1:       number=0;
  bando2Fase3_lotto5:       number=0;
  bando2Fase3_lotto7:       number=0;
  bando2Fase3_lotto8:       number=0;
  bando2Fase3_1:             number=0;
  bando2Fase3_2:             number=0;
  bando2Fase3_3:             number=0;
  bando2Fase3_4:             number=0;
  bando2Fase3_5:             number=0;
  bando2Fase3_6:             number=0;
  bando2Fase3_1_lotto1:     number=0;
  bando2Fase3_1_lotto5:     number=0;
  bando2Fase3_1_lotto7:     number=0;
  bando2Fase3_1_lotto8:     number=0;
  bando2Fase3_2_lotto1:     number=0;
  bando2Fase3_2_lotto5:     number=0;
  bando2Fase3_2_lotto7:     number=0;
  bando2Fase3_2_lotto8:     number=0;
  bando2Fase3_3_lotto1:     number=0;
  bando2Fase3_3_lotto5:     number=0;
  bando2Fase3_3_lotto7:     number=0;
  bando2Fase3_3_lotto8:     number=0;
  bando2Fase3_4_lotto1:     number=0;
  bando2Fase3_4_lotto5:     number=0;
  bando2Fase3_4_lotto7:     number=0;
  bando2Fase3_4_lotto8:     number=0;
  bando2Fase3_5_lotto1:     number=0;
  bando2Fase3_5_lotto5:     number=0;
  bando2Fase3_5_lotto7:     number=0;
  bando2Fase3_5_lotto8:     number=0;
  bando2Fase3_6_lotto1:     number=0;
  bando2Fase3_6_lotto5:     number=0;
  bando2Fase3_6_lotto7:     number=0;
  bando2Fase3_6_lotto8:     number=0;


  bando2KO:                 number=0;
  bando2KO_lotto1:          number=0;
  bando2KO_lotto5:          number=0;
  bando2KO_lotto7:          number=0;
  bando2KO_lotto8:          number=0;

  resetBando1(): void {
    for (const key in this) {
      if (key.startsWith("bando1")) {
        (this as any)[key] = 0;
      }
    }
  }

  resetPFBando1(): void {
    for (const key in this) {
      if (key.startsWith("prontofibraBando1")) {
        (this as any)[key] = 0;
      }
    }
  }

  resetPFBando2(): void {
    for (const key in this) {
      if (key.startsWith("prontofibraBando2")) {
        (this as any)[key] = 0;
      }
    }
  }

  resetBando2(): void {
    for (const key in this) {
      if (key.startsWith("bando2")) {
        (this as any)[key] = 0;
      }
    }
  }

  
}


